import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { getTripStatusConfig } from '../../../common/enums/trip-status.enum';

@Component({
  selector: 'app-trip-status-badge',
  standalone: true,
  imports: [CommonModule],
  template: `
    <span class="text-center" [class]="badgeClasses">
      {{ statusText }}
    </span>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TripStatusBadgeComponent {
  @Input() statusTripId!: number;

  get statusText(): string {
    const config = getTripStatusConfig(this.statusTripId);
    return config?.shortLabel ?? 'Estado Desconocido';
  }

  get badgeClasses(): string {
    const baseClasses =
      'inline-flex items-center rounded-full px-2.5 py-0.5 text-[9.5px] font-bold uppercase tracking-wide !min-w-fit w-[max-content]';
    const config = getTripStatusConfig(this.statusTripId);
    const statusClasses = config?.badgeClasses ?? 'bg-gray-100 text-gray-800 border border-gray-300';
    return `${baseClasses} ${statusClasses}`;
  }
}
